import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { tippspielAPI } from '../services/api';

import { REASON_LABELS } from '../utils/tipLabels';

import PageHeader from '../components/PageHeader';



const TippspielStats = () => {

  const [stats, setStats] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');



  useEffect(() => {

    tippspielAPI.getMyStats()

      .then((res) => setStats(res.data))

      .catch((err) => setError(err.response?.data?.message || 'Statistiken konnten nicht geladen werden.'))

      .finally(() => setLoading(false));

  }, []);



  if (loading) {

    return (

      <div className="flex justify-center py-24">

        <span className="loading loading-spinner loading-lg text-primary" />

      </div>

    );

  }



  if (error) return <div className="alert-error-dark">{error}</div>;



  const breakdownEntries = Object.entries(stats?.breakdown || {}).filter(([, count]) => count > 0);



  return (

    <div className="space-y-8">

      <PageHeader

        kicker="Tippspiel"

        title="Meine Statistik"

        subtitle="Auswertung deiner Tipps in dieser Saison"

        actions={<Link to="/tippen" className="btn-wacker btn-wacker--sm">Weiter tippen</Link>}

      />



      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">

        <div className="stat-card text-center">

          <div className="stat-card-label">Punkte</div>

          <div className="stat-card-value stat-card-value--accent">{stats?.totalPoints ?? 0}</div>

        </div>

        <div className="stat-card text-center">

          <div className="stat-card-label">Platz</div>

          <div className="stat-card-value">

            {stats?.rank ? `${stats.rank}.` : '–'}

            {stats?.totalPlayers > 0 && (

              <span className="text-base font-normal text-white/35"> / {stats.totalPlayers}</span>

            )}

          </div>

        </div>

        <div className="stat-card text-center">

          <div className="stat-card-label">Trefferquote</div>

          <div className="stat-card-value">{stats?.hitRate != null ? `${stats.hitRate}%` : '–'}</div>

        </div>

        <div className="stat-card text-center">

          <div className="stat-card-label">Exakte Tipps</div>

          <div className="stat-card-value">{stats?.exactCount ?? 0}</div>

        </div>

      </div>



      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        <div className="glass-card p-6 md:p-7">

          <h2 className="panel-title">Punkteverteilung</h2>

          {breakdownEntries.length === 0 ? (

            <p className="text-white/50">Noch keine gewerteten Tipps.</p>

          ) : (

            <ul className="space-y-4">

              {breakdownEntries.map(([key, count]) => (

                <li key={key}>

                  <div className="flex justify-between items-center text-sm text-white/80 mb-1.5">

                    <span>{REASON_LABELS[key] || key}</span>

                    <span className="font-bold tabular-nums">{count}</span>

                  </div>

                  <div className="t12-progress">

                    <div

                      className="t12-progress-fill"

                      style={{ width: `${(count / (stats.tipsCount || 1)) * 100}%` }}

                    />

                  </div>

                </li>

              ))}

            </ul>

          )}

        </div>



        <div className="glass-card p-6 md:p-7">

          <h2 className="panel-title">Übersicht</h2>

          <dl className="space-y-3 text-sm">

            {[

              ['Tipps gesamt', stats?.tipsCount ?? 0],

              ['Gewertete Tipps', stats?.scoredCount ?? 0],

              ['Ø Punkte pro Tipp', stats?.averagePoints ?? 0],

              ['Offene Tipps fehlen', stats?.missingTips ?? 0, true],

            ].map(([label, value, warn]) => (

              <div key={label} className="flex justify-between items-center py-2 border-b border-white/[0.04] last:border-0">

                <dt className="text-white/45 uppercase text-xs tracking-wide font-bold">{label}</dt>

                <dd className={`font-bold tabular-nums ${warn && value > 0 ? 'text-amber-400' : 'text-white'}`}>{value}</dd>

              </div>

            ))}

          </dl>

          {(stats?.missingTips ?? 0) > 0 && (

            <Link to="/tippen" className="btn-wacker-outline btn-wacker--sm mt-5 w-full text-center block">

              Fehlende Tipps abgeben

            </Link>

          )}

        </div>

      </div>



      {(stats?.byRound?.length ?? 0) > 0 && (

        <div className="t12-table-wrap">

          <div className="p-5 md:p-6 border-b border-white/10">

            <h2 className="panel-title border-0 pb-0 mb-0">Nach Spieltag</h2>

          </div>

          <table className="t12-table">

            <thead>

              <tr>

                <th>Spieltag</th>

                <th className="text-right">Tipps</th>

                <th className="text-right">Exakt</th>

                <th className="text-right">Punkte</th>

              </tr>

            </thead>

            <tbody>

              {stats.byRound.map((row) => (

                <tr key={row.name}>

                  <td className="font-semibold">{row.name}</td>

                  <td className="text-right tabular-nums text-white/70">{row.tips}</td>

                  <td className="text-right tabular-nums text-white/70">{row.exact}</td>

                  <td className="text-right font-black text-primary-light tabular-nums">{row.points}</td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      )}

    </div>

  );

};



export default TippspielStats;


